import React, { useContext, useState, useMemo } from "react";
import { Context } from "../../../Utility/ContextManager";
import { formatPhoneNumber } from "../../../Utility/index";
import { Modal, Button, Card, Row, Col } from "react-bootstrap";
import envFile from "../../../envFile";

function RentersInsurance(props) {
  const { isMember, tenantWidgets = [] } = props;
  const { propertyManagerInfo } = useContext(Context);
  const [showModal, setShowModal] = useState(false);
  const [currentWidget, setCurrentWidget] = useState(null);

  // Filter widgets based on isMember status and get first 2
  const filteredWidgets = useMemo(() => {
    if (!tenantWidgets || tenantWidgets.length === 0) return [];

    const filtered = tenantWidgets.filter((widget) => {
      if (isMember) {
        return widget.for_member === 1;
      } else {
        return widget.for_tenant === 1;
      }
    });

    return filtered.slice(0, 2);
  }, [tenantWidgets, isMember]);

  const handleWidgetClick = (widget) => {
    if (widget.is_sureapp === 1) {
      setCurrentWidget(widget);
      setShowModal(true);
    } else if (widget.link_url) {
      window.open(widget.link_url, "_blank");
    }
  };

  const handleClose = () => {
    setShowModal(false);
    setCurrentWidget(null);
  };

  // If no widgets available, return null or a fallback
  if (filteredWidgets.length === 0) {
    return null;
  }

  return (
    <div className="details mx-2" style={{ minHeight: "160px", position: "relative" }}>
      <style jsx>{`
        .button-position {
          position: absolute;
          bottom: 8px;
          left: 33.33%;
          transform: translateX(-50%);
          width: auto;
          height: auto;
        }
        @media (min-width: 1400px) {
          .button-position {
            left: 0px;
            transform: none;
          }
        }
        .widget-spacing {
          margin-bottom: 0.2rem !important;
        }
        @media (min-width: 1400px) {
          .widget-spacing {
            margin-bottom: 0.5rem !important;
          }
        }
        .icon-column {
          padding-left: 2.5rem !important;
        }
        @media (min-width: 1400px) {
          .icon-column {
            padding-left: 0.25rem !important;
          }
        }
        /* Reduce horizontal spacing between widgets */
        .widget-row .col,
        .widget-row [class*="col-"] {
          padding-left: 0.25rem !important;
          padding-right: 0.25rem !important;
        }
        @media (min-width: 1400px) {
          .widget-row .col,
          .widget-row [class*="col-"] {
            padding-left: 0.5rem !important;
            padding-right: 0.5rem !important;
          }
        }
        /* Override Bootstrap row gutters for smaller screens */
        .widget-row {
          --bs-gutter-x: 0 !important;
          --bs-gutter-y: 0 !important;
        }
        @media (min-width: 1400px) {
          .widget-row {
            --bs-gutter-x: 1rem !important;
            --bs-gutter-y: 0 !important;
          }
        }
        /* Remove any Card margins */
        .widget-row .card {
          margin: 0 !important;
        }
        /* Responsive font sizing */
        .widget-title {
          font-size: 1rem !important;
          line-height: 1.2 !important;
        }
        .widget-content {
          font-size: 0.875rem !important;
          line-height: 1.3 !important;
        }
        @media (min-width: 768px) {
          .widget-title {
            font-size: 1.1rem !important;
            line-height: 1.3 !important;
          }
          .widget-content {
            font-size: 0.95rem !important;
            line-height: 1.4 !important;
          }
        }
        @media (min-width: 1400px) {
          .widget-title {
            font-size: 1.2rem !important;
            line-height: 1.4 !important;
          }
          .widget-content {
            font-size: 1rem !important;
            line-height: 1.5 !important;
          }
        }
      `}</style>
      <Row className="widget-row">
        {filteredWidgets.map((widget, index) => (
          <Col key={widget.id} xxl={6} xl={12} lg={12} md={12} sm={12} xs={12} className="widget-spacing">
            <Card
              style={{
                borderColor: "#9BD5C3",
                borderWidth: "2px", // Adjust the width as needed
                borderStyle: "solid",
                height: "100%",
              }}
            >
              {" "}
              <Card.Body className="p-xxl-3 p-2 h-100">
                <div
                  style={{ position: "relative", height: "100%", display: "flex", flexDirection: "column" }}
                  className="h-100"
                >
                  <Row className="h-100 flex-grow-1">
                    <Col xs={3} sm={3} className="d-flex align-items-start justify-content-center p-1 icon-column">
                      <img
                        width={55}
                        height={55}
                        className="d-flex align-items-start justify-content-end mt-2 p-1"
                        src={widget.image}
                        alt="Widget Icon"
                        style={{
                          color: "#22c55e",
                        }}
                      />
                    </Col>
                    <Col xs={9} sm={9} className="d-flex justify-content-start h-100">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          height: "100%",
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                      >
                        <div>
                          <p
                            style={{
                              color: "#1a5e61",
                              fontWeight: "bold",
                              margin: "0",
                              whiteSpace: "normal", // Allow normal text wrapping
                            }}
                            className="fw-bold my-1 d-flex justify-content-start text-start mt-2 widget-title"
                          >
                            {widget.title.replace(/\n/g, " ")}
                          </p>
                          <p
                            style={{
                              color: "#000",
                              fontWeight: "normal",
                              margin: "0",
                              whiteSpace: "normal", // Allow normal text wrapping
                            }}
                            className="my-1 d-flex justify-content-start text-start widget-content"
                          >
                            {widget.content.replace(/\n/g, " ")}
                          </p>
                        </div>
                        {/* Button positioned at the bottom */}
                        <div
                          style={{
                            marginTop: "auto",
                            paddingTop: "8px",
                            display: "flex",
                            justifyContent: "start",
                            alignItems: "end",
                          }}
                        >
                          <button
                            className="d-flex align-items-center text-center"
                            style={{
                              height: "2rem",
                              backgroundColor: "#9BD5C3",
                              borderColor: "#1A5E61",
                              color: "#1A5E61",
                              borderRadius: "15px",
                              border: "2px solid #1A5E61",
                              fontSize: "0.875rem",
                              cursor: "pointer",
                              padding: "0 15px",
                              minWidth: "120px",
                              whiteSpace: "nowrap",
                              textAlign: "center",
                              justifyContent: "center",
                            }}
                            onClick={() => handleWidgetClick(widget)}
                          >
                            {widget.button_text}
                          </button>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Modal for SureApp widgets */}
      <Modal show={showModal} onHide={handleClose} size="xl" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">{currentWidget?.title?.replace(/\n/g, " ")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {currentWidget && (
            <iframe
              src={`${envFile.SUREAPP_API_LINK}/product/${
                isMember ? "home-warranty" : "renters-insurance"
              }/?embed=true`}
              style={{ width: "100%", height: "80vh", border: "0" }}
              title={currentWidget.title}
            />
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default RentersInsurance;
